<div id="kt_content" class="kt-content kt-grid__item kt-grid__item--fluid">
  <div class="kt-portlet kt-portlet--mobile">
    <div class="kt-portlet__head">
      <div class="kt-portlet__head-label">
        <h3 class="kt-portlet__head-title">{{ 'Archived Promotion Codes' | translate }}</h3>
      </div>
      <div class="kt-portlet__head-toolbar">
        <button class="btn btn-secondary btn-icon-sm" (click)="onBack()">
          <i class="fas fa-arrow-left"></i>{{ 'Back' | translate }}
        </button>
      </div>
    </div>
    <div class="kt-portlet__body">
      <div class="kt-form kt-form--label-right">
        <form class="row align-items-center" [formGroup]="form">
          <div class="col-12 row mb-2 pr-0 filter-row">
            <div class="col-md-1 kt-form__label col-form-label">
              <label>{{ 'ID' | translate }}:</label>
            </div>
            <div class="col-md-2 kt-form__control">
              <input type="number" formControlName="id" placeholder="{{ 'Search' | translate }}" class="form-control">
            </div>
            <div class="col-md-1 kt-form__label col-form-label">
              <label>{{ 'Promotion' | translate }}:</label>
            </div>
            <div class="col-md-2 kt-form__control">
              <input type="text" formControlName="promotion" placeholder="{{ 'Search' | translate }}" class="form-control" [ngbTypeahead]="this.searchPromo" [resultFormatter]="this.formatPromo" [inputFormatter]="this.formatPromo">
            </div>
          </div>
        </form>
      </div>

      <div class="kt-section col-12 row d-flex justify-content-between mb-3 mt-2">
        <div class="dropdown dropdown-inline">
          <kt-search-button [loading]="searchBtnLoading" [disabledButton]="loading" (search)="onSubmit()"></kt-search-button>
          <kt-clear-button [loading]="clearBtnLoading" [disabledButton]="loading" (clear)="onClear()"></kt-clear-button>
        </div>
      </div>

      <div class="kt-section">
        <div class="kt-section__content">
          <div class="table-responsive">
            <table class="table table-bordered table-hover table-striped">
              <thead>
                <tr>
                  <th>ID</th>
                  <th class="text-center">Category</th>
                  <th>Bonus Type</th>
                  <th class="text-center">Code</th>
                  <th>Promo Name</th>
                  <th>Member Group</th>
                  <th class="date-column">Validity</th>
                  <th class="text-center">Status</th>
                  <th class="text-center">Currencies</th>
                  <th>Bonus Rate</th>
                  <th class="text-center">Game Providers</th>
                  <th class="text-center">Bonus Conditions</th>
                  <th>Created By</th>
                  <th>Archived By</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody *ngIf="(archivedPromotions$ | async) as rows">
                <tr *ngFor="let row of rows">
                  <td>{{ row.id }}</td>
                  <td class="text-center">{{ promoType('PP_CHALLENGE_PHASE_1', row) || promoType('PP_CHALLENGE_PHASE_2', row) ? row.phase_game_provider_category : row.category }}</td>
                  <td>{{ row.bonus_type }}</td>
                  <td class="text-center">{{ row.code }}</td>
                  <td>{{ row.name }}</td>
                  <td>{{ row.member_group ? row.member_group : '-' }}</td>
                  <td class="no-wrap">From: {{ isValidDate(row.valid_from) ? (row.valid_from | timezoneDate: 'YYYY-MM-DD HH:mm') : '' }}<br>
                    To: {{ isValidDate(row.valid_to) ? (row.valid_to | timezoneDate: 'YYYY-MM-DD HH:mm') : '-' }}</td>
                  <td class="text-center">
                    <span class="kt-badge kt-badge--inline kt-badge--pill kt-badge--wide" [ngClass]="'kt-badge--' + row.status"> {{ status[row.status] }}</span>
                  </td>
                  <td class="text-center">{{ row.currencies }}</td>
                  <td>{{ promoType('PP_CHALLENGE_PHASE_1', row) || promoType('PP_CHALLENGE_PHASE_2', row)? '-' : row.bonus_rate }}</td>
                  <td class="text-center">{{ promoType('PP_CHALLENGE_PHASE_1', row) || promoType('PP_CHALLENGE_PHASE_2', row) ? row.phase_game_provider_code : row.game_provider }}</td>
                  <td class="no-wrap">
                    <span class="no-wrap">
                      <i matTooltip="{{ 'Auto Approve' | translate }}" [ngClass]="row.auto_approve > 0 ? 'fas fa-check kt-font-info' : 'fas fa-times kt-font-danger'"></i>
                      {{ 'Auto Approve' | translate }}
                    </span><br>
                    <span class="no-wrap">
                      <i matTooltip="{{ 'Auto Unlock' | translate }}" [ngClass]="row.auto_unlock > 0 ? 'fas fa-check kt-font-info' : 'fas fa-times kt-font-danger'"></i>
                      {{ 'Auto Unlock' | translate }}
                    </span><br>
                    <span class="no-wrap">
                      <i matTooltip="{{ 'Limit Provider Transfer In' | translate }}" [ngClass]="row.limit_transfer_in > 0 ? 'fas fa-check kt-font-info' : 'fas fa-times kt-font-danger'"></i>
                      {{ 'Limit Provider Transfer In' | translate }}
                    </span><br>
                    <span class="no-wrap">
                      <i matTooltip="Limit Provider Transfer Out" [ngClass]="row.limit_transfer_out > 0 ? 'fas fa-check kt-font-info' : 'fas fa-times kt-font-danger'"></i>
                      {{ 'Limit Provider Transfer Out' | translate }}
                    </span><br>
                    <span class="no-wrap">
                      <i matTooltip="Unlock Upon Transfer Out" [ngClass]="row.transfer_unlock > 0 ? 'fas fa-check kt-font-info' : 'fas fa-times kt-font-danger'"></i>
                      {{ 'Unlock Upon Transfer Out' | translate }}
                    </span><br>
                    <span class="no-wrap">
                      <i matTooltip="Allow Cancel Promotion" [ngClass]="row.allow_cancel > 0 ? 'fas fa-check kt-font-info' : 'fas fa-times kt-font-danger'"></i>
                      {{ 'Allow Cancel Promotion' | translate }}
                    </span><br>
                    <span class="no-wrap">
                      <i matTooltip="{{ 'Visible by Affiliate' | translate }}" [ngClass]="row.visible_by_affiliate > 0 ? 'fas fa-check kt-font-info' : 'fas fa-times kt-font-danger'"></i>
                      {{ 'Visible by Affiliate' | translate }}
                    </span><br>
                    <span class="no-wrap">
                      <i matTooltip="{{ 'Last Deposit' | translate }}" [ngClass]="row.last_deposit > 0 ? 'fas fa-check kt-font-info' : 'fas fa-times kt-font-danger'"></i>
                      {{ 'Last Deposit' | translate }}
                    </span><br>
                    <span class="no-wrap">
                      <i matTooltip="{{ 'Restrict Claim If Bonus Round Active' | translate }}" [ngClass]="row.restrict_claim_round_active > 0 ? 'fas fa-check kt-font-info' : 'fas fa-times kt-font-danger'"></i>
                      {{ 'Restrict Claim If Bonus Round Active' | translate }}
                    </span><br>
                    <span class="no-wrap">
                      <i matTooltip="{{ 'Restrict Other Game Launch' | translate }}" [ngClass]="row.restrict_same_provider_launch > 0 ? 'fas fa-check kt-font-info' : 'fas fa-times kt-font-danger'"></i>
                      {{ 'Restrict Other Game Launch' | translate }}
                    </span><br>
                  </td>
                  <td>
                    {{ row.created_by ? row.created_by : 'System' }}<br/>
                    <span placement="bottom" [ngbTooltip]="createdDateTime" container="body" class="text-ellipsis">{{ timezoneDate(row.created_at, 'YYYY-MM-DD HH:mm') }}</span>
                    <ng-template #createdDateTime>
                      {{ timezoneDate(row.created_at, 'YYYY-MM-DD HH:mm:ss') }}
                    </ng-template>
                  </td>
                  <td>
                    {{ row.updated_by ? row.updated_by : 'System' }}<br/>
                    <span placement="bottom" [ngbTooltip]="archivedDateTime" container="body" class="text-ellipsis">{{ timezoneDate(row.deleted_at, 'YYYY-MM-DD HH:mm') }}</span>
                    <ng-template #archivedDateTime>
                      {{ timezoneDate(row.deleted_at, 'YYYY-MM-DD HH:mm:ss') }}
                    </ng-template>
                  </td>
                  <td class="text-center">
                    <button *ngIf="canRestorePromotionCode" matTooltip="Restore"
                      class="btn btn-outline-hover-success btn-elevate btn-sm btn-icon btn-icon-sm"
                      (click)="onRestore(row)">
                      <i class="fas fa-undo"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
              <tbody shared-table-handler [loading]="loading" [dataLength]="dataLength" class="text-gray-600 fw-bold"></tbody>
            </table>
          </div>

          <div class="kt-pagination kt-pagination--brand mt-2" *ngIf="pagination !== undefined">
            <ngb-pagination
              [pageSize]="pageSize"
              [(page)]="page"
              [maxSize]="maxSize"
              [directionLinks]="true"
              [boundaryLinks]="true"
              [rotate]="true"
              [collectionSize]="pagination.total"
              (pageChange)="onViewPageBy(page)">
            </ngb-pagination>
            <div class="kt-pagination__toolbar">
              <select (change)="onPerPage($event)" [(ngModel)]="pageSize" class="form-control kt-font-brand page-size">
                  <option [value]="item" *ngFor="let item of dropdown.perPage">{{ item }}</option>
              </select>
              <span class="pagination__desc">
                Showing {{pagination.from}} to {{pagination.to}} of {{ pagination.total | number : '1.0' }} records
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<kt-swal-alert [message]="messages$ | async"></kt-swal-alert>
